import React, {useCallback, useEffect} from 'react';
import {CF} from 'module/CustomField/util/CustomField';
import {CFComponentProps} from 'module/CustomField/type/CFComponentType';
import {CFValue} from 'module/CustomField/type/CFType';
import {CFAttrKey} from 'module/CustomField/constant/CFAttrConstants'
import {useSelector} from 'react-redux'
import {getMemoSelectedSize, isMemoAutoAddActive} from 'module/Memo/util/MemoUtil'
import {PersonSelectComponent, PersonSelectComponentProps} from 'module/Person/component/PersonSelectComponent'
import {selVisiblePersNrs} from 'module/Person/selector/PersonSelector'
import {MEMO_KEY_PERS} from 'module/Memo/util/MemoKey'

export function CustomFieldPersonSelectComponent(props: CFComponentProps<CFValue>) {
	const {cfDef, setCb, model, disabled, placeholderHTML, pos} = props
	const value = CF.getValueFrom(cfDef, model, {pos})
	const visiblePersNrs = useSelector(selVisiblePersNrs)
	const sfv = CF.getCFAttr(cfDef, CFAttrKey.selectFirstVisible)?.value
	const selectFirstVisible = visiblePersNrs.length < 2 && sfv !== 'N' || sfv === 'J'
	const firstVisiblePers = visiblePersNrs[0]
	const menuWidth = Number(CF.getCFAttr(cfDef, CFAttrKey.menuWidth)?.value)
	useEffect(() => {
		if (selectFirstVisible && !value && firstVisiblePers) {
			setCb(firstVisiblePers)
		}
	}, []);
	const onChange: PersonSelectComponentProps['onChange'] = useCallback((x) => {
		setCb(x || null)
	}, [setCb])
	return (
		<div className={'CustomFieldPersSelectComponent'}>
			<PersonSelectComponent
				persNr={value as number | null}
				onChange={onChange}
				disabled={disabled}
				placeholderHTML={placeholderHTML}
				memo={{memoKey: MEMO_KEY_PERS, memoSize: getMemoSelectedSize(cfDef), memoAutoAdd: isMemoAutoAddActive(cfDef)}}
				menuWidth={menuWidth}
			/>
		</div>
	)
}